"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContactsLists = fetchContactsLists;
exports.fetchContactsListsByIds = fetchContactsListsByIds;
exports.searchContactLists = searchContactLists;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var BASE_URL = '/contacts/v1/lists';

function fetchContactsLists(params) {
  var portalId = _hubspot.default.get();

  var query = (0, _extends2.default)({
    portalId: portalId
  }, params);
  return _apiClient.default.get(BASE_URL, {
    query: query
  });
}

function fetchContactsListsByIds(listId) {
  var portalId = _hubspot.default.get();

  var query = {
    portalId: portalId,
    listId: listId
  };
  return _apiClient.default.get(BASE_URL + "/batch", {
    query: query
  });
}

function searchContactLists(offset) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var q = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var portalId = _hubspot.default.get();

  var query = {
    portalId: portalId,
    count: count,
    q: q
  };
  if (offset) query.offset = offset;
  return _apiClient.default.get(BASE_URL + "/search", {
    query: query
  });
}